import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginSuccess.css';

function LoginSuccess() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const duration = 15000; // 15 seconds
    const interval = 100;
    const increment = 100 / (duration / interval);

    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          navigate('/chat');
          return 100;
        }
        return prev + increment;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <div className="success-card">
        <h1>✅ Login Successful</h1>

        <h2>Welcome to REACH AI</h2>

        <p className="tagline">
          Your personal AI powered health assistant
        </p>

        <div className="loader-wrapper">
          <div className="loader-bar">
            <div
              className="loader-progress"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="loader-text">
            Preparing your health assistant... {Math.floor(progress)}%
          </span>
        </div>

        <p className="hint">
          Please wait while we personalize your experience
        </p>
      </div>
    </div>
  );
}

export default LoginSuccess;
